import React, { Component } from 'react';
import { SimpleForm, TextInput, Toolbar, SaveButton, ReferenceInput, SelectInput, translate } from 'react-admin';
import FieldGroup from '~components/FieldGroup';
import { isRequired } from '~utils/inputValidations';

function SubtemaToolbar(props) {
  return (
    <Toolbar {...props}>
      <SaveButton />
    </Toolbar>
  );
}

class SubtemaForm extends Component {
  render() {
    return (
      <SimpleForm {...this.props} toolbar={<SubtemaToolbar />}>
        {this.props.children}
        <FieldGroup label="fieldGroups.catalogEs">
          <TextInput source="name" validate={isRequired} />
        </FieldGroup>
        <FieldGroup label="fieldGroups.catalogEn">
          <TextInput source="nameEn" />
        </FieldGroup>
        <FieldGroup label="fieldGroups.catalogPt">
          <TextInput source="namePt" />
        </FieldGroup>
        <FieldGroup label="fieldGroups.subtema">
          <ReferenceInput source="theme" reference="themes" validate={isRequired}>
            <SelectInput optionText="name" />
          </ReferenceInput>
        </FieldGroup>
      </SimpleForm>
    );
  }
}

export default translate(SubtemaForm);
